import _ from 'lodash';

import * as api from '../../api';

const upperFirst = (input: string) => {
  if (!input) return '';

  return _.upperFirst(input.toLowerCase());
};

const upperFirstAll = (string: string) => {
  if (!string) return '';

  return string.split(' ').map(upperFirst).join(' ');
};

const getPrettyName = ({
  firstName,
  lastName,
}: api.CareProvider.CareProviderWithAddress) => {
  return [firstName, lastName].map((name) => upperFirstAll(name)).join(' ');
};

const getPrettyAddress = ({
  address,
}: api.CareProvider.CareProviderWithAddress) => {
  const acc: string[] = [];
  for (const [k, v] of Object.entries(address)) {
    if (v) {
      if (k === 'state') {
        acc.push(v);
      } else if (k === 'zip') {
        acc.push(v.slice(0, 5));
      } else {
        acc.push(upperFirstAll(v));
      }
    }
  }
  return acc.join(', ');
};

export const getPrimaryLabel = (
  careProvider: api.CareProvider.CareProviderWithAddress,
) => {
  const { prefix } = careProvider;

  return [
    _.upperFirst((prefix || '').toLowerCase()),
    getPrettyName(careProvider),
  ].join(' ');
};

export const getSecondaryLabels = (
  careProvider: api.CareProvider.CareProviderWithAddress,
) => {
  return [careProvider.taxonomy, getPrettyAddress(careProvider)];
};
